import { Checkbox } from "primereact/checkbox";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";
import { InputText } from "primereact/inputtext";
import {
  getCustomerSingleOrderPackage,
  postOrderItemQrCodeMap,
} from "../../services/OrdersAPI/Orders";
import { getUserData } from "../../utils/localStorage";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const GarmentEditWithScanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    qrCodeData,
    orderItemData,
    storeCustomerId,
    bookingOrderId,
    orderBookingType,
  } = location.state || {}; // Fallback to prevent undefined errors
  const { storeData } = getUserData();

  const storeId = storeData.id;

  const [scannedQr, setScannedQr] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [qrCodes, setQrCodes] = useState([]);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [totalPackageCountValue, setTotalPackageCountValue] = useState(1);
  const [packageBooingItemCount, setPackageBooingItemCount] = useState({});
  const [packageCountError, setPackageCountError] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);

  useEffect(() => {
    setQrCodes(qrCodeData.map((item) => ({ ...item, checked: false })));
    if (qrCodeData) {
      setTotalPackageCountValue(0.1);
    }

    if (orderBookingType.bookingType === "PackageBooking") {
      getCustomerSingleOrderPackage(
        storeCustomerId,
        storeId,
        bookingOrderId,
        qrCodeData[0].orderItemAddOn.priceListId
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const totalCount = Res.itemCount + Res.countGram;
            setPackageBooingItemCount(totalCount);
          }
        })
        .catch((err) => {
          console.error("getCustomerSingleOrder Error:", err);
        });
    }
  }, [qrCodeData]);

  useEffect(() => {
    if (scannedQr) {
      const updatedQrCodes = qrCodes.map((qr) => {
        if (qr.qrcode === scannedQr) {
          return { ...qr, checked: true };
        }
        return qr;
      });
      setQrCodes(updatedQrCodes);
      setSelectedQrCodes(
        updatedQrCodes.filter((qr) => qr.checked).map((qr) => qr.qrcode)
      );
    }
  }, [scannedQr]);

  useEffect(() => {
    if (searchTerm !== "") {
      // Filter QR codes based on the search term, case insensitive
      const filteredQrCodes = qrCodeData.filter((qr) =>
        qr.qrcode.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      // Update the qrCodes state with filtered results
      setQrCodes(filteredQrCodes.map((item) => ({ ...item, checked: false })));
    } else {
      // If no search term, reset to original qrCodeData
      setQrCodes(qrCodeData.map((item) => ({ ...item, checked: false })));
    }
  }, [searchTerm, qrCodeData]); // Dependencies are searchTerm and qrCodeData

  const generalBookingItemCount = parseFloat(
    qrCodes[0]?.orderItemAddOn.count + qrCodes[0]?.orderItemAddOn.countGram
  ).toFixed(2);

  const requiredItemCount =
    orderBookingType.bookingType === "PackageBooking"
      ? packageBooingItemCount
      : generalBookingItemCount;

  const handleScan = ({ data }) => {
    setQrCodes((prevQrCodes) => {
      const updatedQrCodes = prevQrCodes.map((qr) => {
        if (qr.qrcode === data) {
          return { ...qr, checked: !qr.checked };
        }
        return qr;
      });

      // Calculate new selected QR codes
      const newSelectedQrCodes = updatedQrCodes
        .filter((qr) => qr.checked)
        .map((qr) => qr.qrcode);

      // Update selected QR codes
      setSelectedQrCodes(newSelectedQrCodes);

      return updatedQrCodes;
    });
  };

  const renderCardItem = () => {
    return qrCodes.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrcode}</p>
        <p className="flex-1 text-lg font-normal text-center">
          {(item.serviceName + "").substring(0, 15)}
          {(item.serviceName + "").length > 15 ? "..." : ""}
        </p>

        <div className="flex-1 text-lg font-normal text-right">
          <div>
            <Checkbox
              size={12}
              checked={item.checked ? true : false}
              color={item.checked ? "#00A3FF" : "#C1C9D3"}
              onClick={() => handleScan({ data: item.qrcode })}
            />
          </div>
        </div>
      </div>
    ));
  };

  const handleUnProcessGarment = () => {
    if (!isSendButtonPressed) {
      setIsSendButtonPressed(true);
      let itemCount = 0;
      let countGram = 0;
      if (qrCodes[0]?.orderItemAddOn.serviceUnit === "Kg") {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      } else {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      }

      const data = {
        qrCodeList: selectedQrCodes,
        status: "UNPROCESSED",
        removeCount:
          selectedQrCodes.length === qrCodeData.length
            ? qrCodes[0]?.orderItemAddOn.serviceUnit !== "Qty" &&
              orderBookingType.bookingType === "PackageBooking"
              ? itemCount + countGram
              : generalBookingItemCount
            : itemCount + countGram,
      };

      if (!isNaN(totalPackageCountValue)) {
        postOrderItemQrCodeMap(storeCustomerId, storeId, bookingOrderId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              const message = Res.message;
              const success = Res.status;
              if (success === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
                setTimeout(() => {
                  navigate("/GarmentEdit", {
                    state: {
                      storeCustomerId: storeCustomerId,
                      bookingOrderId: bookingOrderId,
                      storeId: storeId,
                    },
                  });
                }, 1500);
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      } else {
        setPackageCountError(
          "Input is not a number Please enter correct number"
        );
      }
    }
  };

  const incrementPackageCount = () => {
    const incrementedCount = parseFloat(totalPackageCountValue) + 0.1;
    // setTotalPackageCountValue(incrementedCount.toFixed(1)); // Ensure fixed decimal places

    if (incrementedCount < requiredItemCount) {
      setTotalPackageCountValue(incrementedCount.toFixed(1)); // Ensure fixed decimal places
      setPackageCountError("");
    } else {
      setPackageCountError("Entered Value Cannot Be Greater Then Actual Value");
    }
  };
  const decrementPackageCount = () => {
    const decrementedCount = parseFloat(totalPackageCountValue) - 0.1;
    if (decrementedCount >= 0.1) {
      setTotalPackageCountValue(decrementedCount.toFixed(1)); // Ensure fixed decimal places
      setPackageCountError("");
    } else {
      setPackageCountError("Entered Value cannot be Zero");
    }
  };

  const handlePackageCountChange = (text) => {
    if (text === "") {
      // Handle clearing the input field
      setTotalPackageCountValue("");
      setPackageCountError("Entered Value cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackageCount = text;
      setTotalPackageCountValue(newPackageCount);

      // Parse the value to check against the maximum allowed value
      const parsedValue = parseFloat(newPackageCount);
      if (!isNaN(parsedValue)) {
        if (parsedValue < requiredItemCount) {
          setPackageCountError("");
        } else {
          setPackageCountError(
            "Entered Value Cannot Be Greater Then Actual Value"
          );
        }
      } else {
        // Handle invalid input
        setPackageCountError("Please Enter Correct Value");
      }
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-1">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/GarmentEdit", {
                      state: {
                        orderItemData: orderItemData,
                        storeCustomerId: storeCustomerId,
                        bookingOrderId: bookingOrderId,
                        storeId: storeId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Garment Edit
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
      <div className="my-3 mx-5 flex flex-1">
                  <IconField iconPosition="left" className="flex flex-1">
                    <InputIcon className="pi pi-search text-xl"> </InputIcon>
                    <InputText
                      placeholder="Search Qr Code"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="text-xl flex flex-1 py-1"
                      style={{ borderRadius: 30 }}
                    />
                  </IconField>
                </div>
        <div className="mx-3">
          <div className="flex flex-row py-1 mx-2 justify-content-between">
            <p className="flex-1 text-2xl font-medium ">Tag</p>
            <p className="flex-1 text-2xl font-medium text-center">Service</p>

            <p className="flex-1 text-2xl font-medium text-right">Status</p>
          </div>
          {renderCardItem()}
          <div className="relative flex flex-column justify-content-center align-items-center" style={{ marginTop: 140 }}>
            <div style={{ marginBottom: 10,  }} className="fixed z-2 bottom-0 w-full">
              {selectedQrCodes.length > 0 &&
              (orderBookingType.bookingType === "PackageBooking" ||
                selectedQrCodes.length < qrCodeData.length) ? (
                <div>
                  {qrCodes[0]?.orderItemAddOn.serviceUnit !== "Qty" && (
                    <div
                      style={{
                        marginTop: 5,
                        marginBottom: 10,
                        alignSelf: "center",
                      }}
                    >
                      <div className="flex-1 mx-2 my-1">
                        <div className="flex flex-row justify-content-center align-items-center">
                          <div>
                            <p className="text-xl font-bold text-center">
                              Remove{" "}
                              {qrCodes[0]?.orderItemAddOn.serviceUnit === "Kg"
                                ? "Weight"
                                : "Area"}{" "}
                            </p>
                          </div>
                          <div
                            onClick={() => decrementPackageCount()}
                            className="justify-content-center align-items-center  shadow-4 mx-2  cursor-pointer"
                            style={{
                              backgroundColor: "#2B70D7",
                              borderRadius: 50, // Make it circular (adjust the value as needed)
                              width: 30, // Width of the button
                              height: 30, // Height of the button
                            }}
                          >
                            <p className="text-xl font-bold text-white text-center">
                              -
                            </p>
                          </div>
                          <div className="text-xl font-bold text-white text-center">
                            <InputText
                              value={totalPackageCountValue.toString()} // input must be string
                              onChange={(e) =>
                                handlePackageCountChange(e.target.value)
                              }
                              keyboardType="numeric"
                            />
                          </div>
                          <div
                            onClick={() => incrementPackageCount()}
                            className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                            style={{
                              backgroundColor: "#2B70D7",
                              borderRadius: 50, // Make it circular (adjust the value as needed)
                              width: 30, // Width of the button
                              height: 30, // Height of the button
                            }}
                          >
                            <p className="text-xl font-bold text-white text-center">
                              +
                            </p>
                          </div>
                        </div>
                      </div>
                      {packageCountError !== "" && (
                        <p
                          className="text-xl font-bold text-center mt-2"
                          style={{ color: "red" }}
                        >
                          {packageCountError}
                        </p>
                      )}
                    </div>
                  )}
                  <SuccessModal
                    setModalVisible={setModalVisible}
                    modalVisible={modalVisible}
                    status={modalStatus}
                    text={modalText}
                  />
                </div>
              ) : (
                ""
              )}
              {selectedQrCodes.length > 0 && (
                <div className="flex-1 mx-2 mb-1 mt-3 w-full">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleUnProcessGarment}
                      disabled={
                        !isSendButtonPressed
                          ? totalPackageCountValue > requiredItemCount
                          : isSendButtonPressed
                      }
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        UNPROCESS
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                          style={{ width: 30 }}
                        />
                        <div
                          style={{
                            left: 25,
                            position: "absolute",
                            top: -8,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 26,
                            height: 26,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              left: 7,
                              position: "absolute",
                              top: -4,
                            }}
                          >
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GarmentEditWithScanner;
